import React from "react";
import { Outlet } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import "../../src/index.css";

const Dashboard = () => {
  return (
    <Container fluid>
      <Row>
        <Col xs={2} className="p-0">
          <Sidebar />
        </Col>
        <Col xs={10} className="p-4 bg-template">
          <div className="container mt-5">
            <div class="card">
              <div class="card-body">
                <Outlet />{" "}
                {/* Aquí se renderizan los componentes basados en la ruta */}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Dashboard;
